import { Gem, Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

interface BulkDeactivateDialogProps {
  isOpen: boolean;
  onClose: () => void;
  count: number;
  onConfirm: () => Promise<void>;
  isLoading?: boolean;
}

export const BulkDeactivateDialog = ({
  isOpen,
  onClose,
  count,
  onConfirm,
  isLoading = false,
}: BulkDeactivateDialogProps) => {
  const handleConfirm = async () => {
    await onConfirm();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Gem className="h-5 w-5 text-primary" />
            Mark {count} deal{count === 1 ? "" : "s"} as not premium
          </DialogTitle>
          <DialogDescription>
            {count === 1 ? "This deal" : `These ${count} deals`} will no longer
            be premium and premium reports will stop generating. You can make a
            deal premium again later by generating a premium report.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex gap-2">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button onClick={handleConfirm} disabled={isLoading}>
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Updating...
              </>
            ) : (
              "Mark as not premium"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
